import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./Recuperar.component.scss";

const RecuperarComponent = ({ clickRecuperar, clickEnviar }) => {
  const [correo, setCorreo] = useState("");

  const handleClickRecuperar = () => {
    clickRecuperar(false);
  };

  const handleClickEnviar = () => {
    clickEnviar(correo);
  };

  return (
    <>
      <div className="row mt-5">
        <div className="col-12">
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Correo</Form.Label>
              <Form.Control
                name="Correo"
                type="email"
                placeholder="Correo"
                value={correo}
                onChange={(e) => {
                  setCorreo(e.target.value);
                }}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12 col-lg-6">
          <Button
            variant="link"
            type="button"
            block="true"
            onClick={handleClickRecuperar}
          >
            Cancelar
          </Button>
        </div>
        <div className="col-12 col-lg-6">
          <Button
            variant="secondary"
            type="button"
            block="true"
            onClick={handleClickEnviar}
          >
            Enviar
          </Button>
        </div>
      </div>
    </>
  );
};

export default RecuperarComponent;
